import * as Commons from "oc-commons/Commons";

/**
 * Ein Interval2 stellt ein geschlossenes Zahlen-Intervall von-bis dar, das speziell für den Wkfg2TypeConverter als Rückgabetyp dient
 */
export class Interval2 {
  /**
   * @param string
   * @returns
   */
  static parse(string: string | null | undefined): Interval2 | null {
    if (Commons.isEmpty(string) || string == null) {
      return null;
    }
    const groups = string.match(/^(\s*[+-]?\d+(?:\.\d+)?)\s*(?:[-]\s*([+-]?\d+(?:\.\d+)?)\s*)?$/);
    if (!groups) {
      return null;
    }
    const interval = groups.slice(1).map((x) => (x ? parseFloat(x) : undefined));
    const min = interval[0];
    const max = interval[1];
    if (min === undefined) {
      return null; // Should not happen given regex
    }
    return new Interval2(min, max);
  }

  public min: number;
  public max: number | undefined;

  constructor(min: number, max: number | undefined = undefined) {
    if (min == null) {
      throw new Error("min value must be set");
    }
    this.min = min;
    this.max = max;
  }

  includes(number: number, epsilon: number = 0.000001): boolean {
    if (this.max == null) {
      return Math.abs(this.min - number) < epsilon;
    }
    return this.min <= number && number <= this.max;
  }

  intersects(another: Interval2, epsilon: number = 0.000001): boolean {
    const anotherMax = another.max;
    return (
      this.includes(another.min, epsilon) ||
      (anotherMax != null && this.includes(anotherMax, epsilon)) ||
      another.includes(this.min, epsilon) ||
      (this.max != null && another.includes(this.max, epsilon))
    );
  }

  toString(): string {
    if (this.max == null) {
      return "" + this.min;
    }
    return this.min + " - " + this.max;
  }
}
